<template>
  <div>
    <p :class="['px-2', 'pt-3', 'navigation-intro-text']">
      <intro-text /> Please, consider a <a :href="$store.state.meta.links[0].href" target="_blank">donation</a> if you find this service useful.
    </p>
    <v-list :class="['mb-2']" dense>
      <template v-for="(value, key) in items">
        <v-list-tile :key="key" avatar ripple router :to="key">
          <v-list-tile-avatar>
            <v-icon>folder</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{ key }}</v-list-tile-title>
            <v-list-tile-sub-title>{{ value.length }} icons</v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-icon>chevron_right</v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <v-divider :key="`${key}-divider`" />
      </template>
    </v-list>
    <p hidden>
      <span class="synced">Last synced: {{ $store.getters.date }}</span>
    </p>
    <!--<div :class="['ma-4']">-->
      <!--<vue-adsense :style="adStyle" :ad-client="adClient" :ad-slot="adSlot" :ad-format="adFormat" />-->
    <!--</div>-->
  </div>
</template>
<script>
import IntroText from './intro-text'

export default {
  name: 'NavigationBar',
  components: {
    IntroText
  },
  data () {
    return {
      adClient: this.$store.state.googleAdSenseAdClient,
      adSlot: '5277093631',
      adFormat: 'auto',
      adStyle: {
        display: 'inline-block',
        width: '234px',
        height: '60px',
        overflow: 'hidden'
      }
    }
  },
  props: [
    'items'
  ]
}
</script>
<style>
.synced
{
  font-variant: all-small-caps;
  color: #757575;
  font-size: 12px;
}

.navigation-intro-text
{
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/navigation-bar.vue